import { Action, AppSettings } from "src/state/_types";

export const loadSettings: Action = async ({state,actions,effects}) => {
    let settings = effects.loadLocalStorageSettings() as unknown as AppSettings
    if (settings) {
        state.settings = settings
        if (!!settings.locale) {
            actions.setLocale(settings.locale)
        }
    }
}